import { render, staticRenderFns } from "./DadosEssenciais.vue?vue&type=template&id=5c6a5812&scoped=true"
import script from "./DadosEssenciais.vue?vue&type=script&lang=js"
export * from "./DadosEssenciais.vue?vue&type=script&lang=js"
import style0 from "./DadosEssenciais.vue?vue&type=style&index=0&id=5c6a5812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a5812",
  null
  
)

export default component.exports